import DOMPurify from 'dompurify'

const visibleText = (value) => String(value || '').replace(/[\u200B-\u200D\uFEFF]/g, '').trim()
function richTextVisible(value) {
  const element = document.createElement('div')
  element.innerHTML = DOMPurify.sanitize(String(value || ''), { USE_PROFILES: { html: true } })
  return visibleText(element.textContent)
}

// 每次成功登录读取最新开关，旧的空HTML配置不生成空弹框。
export function buildLoginPublicPopups(setting = {}) {
  const queue = []
  if (Number(setting.securityPromptStatus) === 1 && visibleText(setting.securityPromptContent)) {
    queue.push({ kind: 'security', title: '安全提示', content: setting.securityPromptContent, button: '我知道了' })
  }
  if (Number(setting.customerPopupStatus) === 1 && richTextVisible(setting.customerPopupTitle) && richTextVisible(setting.customerPopupContent) && visibleText(setting.customerPopupButton)) {
    queue.push({ kind: 'customer', title: setting.customerPopupTitle, content: setting.customerPopupContent, button: setting.customerPopupButton })
  }
  return queue
}
